import type { FaireProductEntity } from "../../entity_types/product";

export const p_xa3af3p6z4: FaireProductEntity = {
  token: "p_xa3af3p6z4",
  type: "product",
  name: "Local New England Foods Collection - Everyday Greeting Card",
  brandToken: "b_2nlyab4cca",
  brandName: "Sarah Wormann Art",
  imageUrl: "https://cdn.faire.com/fastly/a3d3920c01af444f5579b4d64e006bda2d21ef8e00981250f277feacfd015848.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b959344a37d07575bcce5a7b832c0c7a8f39d8f6c89ebdec06332e5a50363567.png",
    "https://cdn.faire.com/fastly/a7a4818c7311dae90985b8ad1f7be870b93b6bedc1f580938e33c8e49164c293.jpeg"
  ],
  priceDollars: 3,
  description: "Greeting card version of the popular New England Foods print!\n\nSmall-batch greeting card created, printed, and packaged by hand in Boston, MA. Perfect for gift shops and boutiques seeking unique, locally-made stationery.\n\nDetails:\n• Standard A2 greeting card size: 4.25\" x 5.5\"\n• Blank inside for personalization\n• Includes coordinating envelope\n• Comes in a protective clear sleeve, ready for display\n\nEach card is created by Sarah in her Boston home studio, offering customers unique designs with a personal, handcrafted touch.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:14.854Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
